import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { UserProfileProvider } from './context/UserProfileContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { PriestAuthProvider } from './context/PriestAuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Horoscope from './pages/Horoscope';
import Compatibility from './pages/Compatibility';
import Numerology from './pages/Numerology';
import Tarot from './pages/Tarot';
import VedicAstrology from './pages/VedicAstrology';
import Transits from './pages/Transits';
import ChineseZodiac from './pages/ChineseZodiac';
import AskAstrologer from './pages/AskAstrologer';
import MoonPhase from './pages/MoonPhase';
import Muhurat from './pages/Muhurat';
import Nakshatra from './pages/Nakshatra';
import Remedies from './pages/Remedies';
import Profile from './pages/Profile';
import PalmReading from './pages/PalmReading';
import Kundali from './pages/Kundali';
import AccuracyTest from './pages/AccuracyTest';
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import PriestLogin from './pages/PriestLogin';
import PriestSignup from './pages/PriestSignup';
import PriestDashboard from './pages/PriestDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import TempleMap from './pages/TempleMap';
import GrievanceOfficer from './pages/GrievanceOfficer';
import RefundPolicy from './pages/RefundPolicy';
import PriestTerms from './pages/PriestTerms';
import Accessibility from './pages/Accessibility';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
    <PriestAuthProvider>
    <AdminAuthProvider>
    <UserProfileProvider>
    <LanguageProvider>
    <Router>
      <div className="app">
        <div className="stars-bg" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/horoscope" element={<Horoscope />} />
          <Route path="/compatibility" element={<Compatibility />} />
          <Route path="/numerology" element={<Numerology />} />
          <Route path="/tarot" element={<Tarot />} />
          <Route path="/vedic" element={<VedicAstrology />} />
          <Route path="/transits" element={<Transits />} />
          <Route path="/chinese" element={<ChineseZodiac />} />
          <Route path="/ask" element={<AskAstrologer />} />
          <Route path="/moon" element={<MoonPhase />} />
          <Route path="/muhurat" element={<Muhurat />} />
          <Route path="/nakshatra" element={<Nakshatra />} />
          <Route path="/remedies" element={<Remedies />} />
          <Route path="/palm" element={<PalmReading />} />
          <Route path="/kundali" element={<Kundali />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/accuracy-test" element={<AccuracyTest />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/grievance-officer" element={<GrievanceOfficer />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/priest/terms" element={<PriestTerms />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/priest/login" element={<PriestLogin />} />
          <Route path="/priest/signup" element={<PriestSignup />} />
          <Route path="/priest/dashboard" element={<PriestDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/temples" element={<TempleMap />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
    </LanguageProvider>
    </UserProfileProvider>
    </AdminAuthProvider>
    </PriestAuthProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
